import React, { Component } from 'react';
import FieldModal from '../../../components/modals/fieldModal';

class DeleteBookingModal extends Component {
	state = {
		submitting: false
	};

	handleDelete = () => {
		this.setState({ submitting: true });
		this.props.delete();
	};

	render() {
		const { isOpen, count, toggle } = this.props;
		const { submitting } = this.state;
		
		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle={`Delete ${count > 1 ? 'Booking Pages' : 'Booking Page'}`}
				bodyHeaderText={
					<span>
						You are about to delete{' '}
						<b>
							{count} {count > 1 ? 'booking pages' : 'booking page'}
						</b>
						, this is irreversible, would you like to continue?
					</span>
				}
				bodyContent={() => {
					if (count > 1) {
						return (
							<div className="mt-15">
								<p className="small grey mb-10">
									<i className="las la-exclamation-triangle mr-5"></i>
									This will also delete all associated:
								</p>
								<ul className="small grey mb-0" style={{ paddingLeft: '20px' }}>
									<li>Calendar configurations and availability settings</li>
									<li>Scheduled meetings and booking history</li>
									<li>Custom styling and page configurations</li>
								</ul>
							</div>
						);
					}
					return "";
				}}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
				actionButton={this.handleDelete}
				actionButtonDisabled={submitting}
				isDelete={true}
			/>
		);
	}
}

export default DeleteBookingModal;
